module.exports = __webpack_public_path__ + "img/z (6).5f33a1dd.png";